import * as ActionTypes from "../constants/ActionTypes";

// **************************************************************************************************************
export const accountsReducer = (state = {}, action) => {
    switch (action.type) {
        case ActionTypes.ACCOUNTS_SUCCESS:
            return Object.assign({}, state, action.response.entities && action.response.entities.account)

        default:
            return state
    }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/Accounts.js
 **/